const ROUTES = {
  SIGNIN: "/",
  LOGOUT: "logout",
  NOT_FOUND: "*",
  HOME: "home",
  DASHBOARD: "dashboard",
  CATEGORIES: "types",
  ADMINS: "admins",
  STORES: "stores",
  SETTINGS: "settings",
  SCRAP_SALES_REQUESTS: "scrap-sales-requests",
  SCRAP_SALES_REQUESTS_UAE: "scrap-sales-requests-uae",
  REDEEM_POINTS_REQUESTS: "redeem-points-requests",
  REDEEM_POINTS_REQUESTS_UAE: "redeem-points-requests-uae",
  SUPPLYING_TYPES: "supplying-types",
  NOT_HAVE_ACCESS: "not-have-access",
  DEALERS: "scrappers",
  ACCEPTED_REQUESTS_REPORT: "accepted-requests-report",
  HOME_BANNER: "home-banner",
  MARKETPLACE_BANNER: "marketplace-banner",
  COURIER: "couriers",
  COURIER_REPORT: "courier-report",
  SOCIAL_ORDERS: "social-orders",
  SOCIAL_ORDERS_UAE: "social-orders-uae",
  GOVERNMENT: "governments",
  CTIY: "areas",
  DAILY_COURIES: "daily-couriers",
  COMPLETED_ORDERS: "completed-orders",
  DO_DONT_IMAGES: "do-dont-images",
  STORE_PRODUCTS: "store-products",
  STORE_CATEGORIES: "store-categories",
  STORE_SUBCATEGORIES: "store-subcategories",
  GULF_PRODUCTS: "gulf-products",
  GULF_CATEGORIES: "gulf-categories",
  GULF_SUBCATEGORIES: "gulf-subcategories",
  GULF_GOVERMENT: "gulf-goverment",
  GULF_DISTRICT: "gulf-district",
  NOTIFICATION: "notification",
  PARTNERS: "partners",
  PARTNERSHIP: "partnership",
  CHAT_SCOUTS: "scouts-chat",
  CHAT_SCRAPPERS: "scrappers-chat",
  MERCHANT_SALES_REQUESTS: "merchant-sales-requests",
  MERCHANT_STORE_ORDERS: "merchant-store-orders",
  PENDING_CASH_REQUEST: "pending-cash-request",
  WITHDRAWLS: "Withdrawls",

  SALES_REQUESTS_RETURNS: "sales-requests-returns",
  MERCHANT_PERIODS: "merchant-periods",
  MERCHANT_SCRAP_TYPES: "merchant-scrap-types",
  MERCHANT_NATIONAL_ID: "merchant-national-id",
  COURIER_DISTRICTS: "courier-districts",
  COMMUNITY_CATEGORIES: "community-categories",
  COMMUNITY_SUBCATEGORIES: "community-subcategories",
  ACCEPTED_POSTS: "accepted-posts",
  ALL_PENDING_POSTS: "pending-posts",
  ALL_REJECTED_POSTS: "rejected-posts",
  CASH_TRANSFER: "cash-transfer",
  ADMIN_POSTS: "admin-posts",
  INSTALLMENT_PLANS: "installment-plans",
  INSTALLMENT_REQUESTS: "installment-requests",
  INSTALLMENT_PENDING_ORDERS: "installment-pending-orders",
  INSTALLMENT_ACCEPTED_ORDERS: "installment-accepted-orders",
  INSTALLMENT_STATISTICS: "installment-statistics",
  CUSTOMER_PAYMENT_DUES: "customer-payment-dues",
  ADMIN_PAYMENT_DUES: "admin-payment-dues",
  STOCK_MERCHANTS: "stock-merchants",
  STOCK_BUYERS: "stock-buyers",
  STOCK_MERCHANT_ORDERS: "stock-merchant-orders",
  STOCK_BUYER_ORDERS: "stock-buyer-orders",
  STOCK_DAILY_COURIERS: "stock-daily-couriers",
  STOCK_SCRAP_TYPES: "stock-scrap-types",
  STORE_BALANCES: "store-balances",
  TRACK_COURIER_DEFICIT: "track-courier-deficit",
  COURIER_TRACKING: "courier-tracking",
  ATTRIBUTES_KEYS: "attributes-keys",
  LINKING_ATTRIBUTES: "linking-attributes",
  INITIAL_SCRAP_BALANCE: "initial-scrap-balance",
  ZONES: "zones",
  RATES: "rates",
  SELECT_SHOP: "select-shop",
  COURIER_WEIGHTS: "courier-weights",
  QUESTIONS_CATEGORIES: "questions-categories",
  QUESTIONS: "questions",
  MERCHANT_BUY_ITEM: "merchant-buy-item",
  PENDING_MERCHANT_BUY_ORDERS: "pending-merchant-buy-orders",
  ALL_MERCHANT_BUY_ORDERS: "all-merchant-buy-orders",
  SCRAPTION_COMPANY: "scraption-company",
  SUPPLIERS: "suppliers",
  PENDING_SCRAP_REQUEST: "pending-scrap-request",
  INACTIVE_USER_REQUEST: "inactive-user-request",
  ORDER_STATISTICS: "order-statistics",
  // Orders: "/orders",
  // PENDINGORDERS: "/pending-orders",
  // ITEMS: "/items",
  // DEALERSCHECKS: "/scrappers-checks",
  // SALESREQUESTS: "/scrappers-sales-requests",
  // SCRAPPERSSALESREQUESTS: "/robabekia-sales-requests",
};

export default ROUTES;
